
import { mapGetters } from 'vuex'
import { getBaseUrl } from '~/config/api'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import TextInput from '~/components/Registration/input/index.vue'

export default {
  name: 'PromoCode',
  components: {
    TextInput,
  },
  mixins: [ui],
  props: {},
  data() {
    return {
      promoModal: false,
      promoCode: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    })
  },
  watch: {},
  created() {
  },
  methods: {
    async applyPromo() {
      try {
        this.showFSLoader()

        await this.$axios.post(`${getBaseUrl()}/api/v2/practice-locations/apply-promo`, { promo_code: this.promoCode })

        this.showAlert({
          type: 'success',
          content: 'Promo code applied successfully!'
        })

        await this.$store.dispatch('user/SetUserPracticeLocation')
      } catch (e) {
        console.error('onConfirm', e)

        this.showAlert({
          type: 'error',
          content: e.response?.data?.error ?? 'Invalid promo code. Please try again.'
        })
      } finally {
        this.hideFSLoader()
        this.promoModal = false
      }
    }
  }
}
